import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import { connect } from 'react-redux';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import locale from './locale'
import addClient from 'controllers/client/addClient'
import editClient from 'controllers/client/editClient'
import {fetchClientList} from 'containers/pages/PotentialClient/ducks'
import getClientDetail from 'controllers/client/getClientDetail'

const mapStateToProps = (state) => ({
  clientList: state.clientList
})

const mapDispatchToProps = (dispatch) => {
	return {
    fetchClientList: (obj) => dispatch(fetchClientList(obj)),
	};
};

class ModalBody extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      disabledBtn: false,
      customFormData: {},
    }

    this.onSubmit = this.onSubmit.bind(this)
    this.onCustomDataChange = this.onCustomDataChange.bind(this);
    
  }

  componentWillMount(){
    if(this.props.clientId){
      getClientDetail(this.props.clientId)
      .then((res) => {
        this.setState({customFormData:res.custom_data})
      })
    }
  }

  onSubmit(){
    if(this.formData == undefined){
      return alert.warning(__('All Fields with * Must Be Filled', locale)).then(() => {this.setState({disabledBtn: false})})
    }

    if(this.formData.mobile_parsed.national_number && this.formData.mobile_parsed.national_number.length < 5){
      return alert.warning(__('Please enter a valid phone number', locale)).then(() => {this.setState({disabledBtn: false})})
    }
    const customDataValidateResult = this.customDataValidate();
    
    if (!customDataValidateResult.ok) {
      this.setState({disabledBtn: false})
      return;
    }
    const schoolId = localStorage.getItem('schoolId')
    let {mobile_parsed, tag_name_list, gender, first_name, last_name, date_of_birth} = this.formData;
    let newPhone = mobile_parsed.national_number? (mobile_parsed.country_code.toString() + mobile_parsed.national_number.toString()) : ''
    
    let newTags = [];
    if(tag_name_list.length > 0){
      tag_name_list.map((tag) => {
        newTags.push(tag.text)
      })
    }
    
    if(!first_name || !last_name || !gender || !mobile_parsed){
      return alert.warning(__('All Fields with * Must Be Filled', locale)).then(() => {this.setState({disabledBtn: false})})
    }
    
    if(gender == ''){
      delete this.formData.gender
    }
    delete this.formData.mobile_parsed
    
    let newData = {...this.formData, mobile: newPhone, tag_name_list: newTags, custom_data: this.state.customFormData}
    let addorEdit = this.props.clientId ? editClient : addClient
    let Id = this.props.clientId ? this.props.clientId : schoolId

    addorEdit(Id, newData)
    .then((res) => {
      if(res.result == 'success'){
        this.props.proceed()
      }
    })
  }
  onCustomDataChange(customFormData){
    this.setState({
      customFormData:{
        ...this.state.customFormData,
        ...customFormData,
      }
    })
  }
	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
      type
    } = this.props;
    const { customFormData } = this.state;
    
		return (
			<Modal
				className='attendance-scam-modal'
				hasHeader={true}
				hasFooter={true}
				headerTitle={type === 'edit'? __("Edit Contact", locale) : __("Add Contact", locale)}
        fixedWidth={600}
        contentHeight={530}
        onCloseModalClick={dismiss}
        footerType="grey"
        footerButtons={[
          {
            title: __('Save', locale),
            className: 'btn btn-primary pull-right',
            onClick: ()=>{
              this.setState({disabledBtn: true},()=>{
                this.onSubmit();
              })
            },
            isDisabled: ()=>{
              return this.state.disabledBtn
            }
          },
          {
            title: __('Cancel', locale),
            className: 'btn btn-default pull-right',
            onClick: () => {
              dismiss()
            }
          }
        ]}
        isShowingModal={show} >
        <ModalContent
          {...this.props}
          onCustomDataChange={this.onCustomDataChange}
          //scrollingContainerRef={this.modalContentRef}
          customFormData={customFormData}
          getCustomDataValidationRef={(fn)=>{
            this.customDataValidate = fn;
          }}
          onFormChange={(stateFromModalContent)=>{ this.formData = stateFromModalContent; }}
        />
			</Modal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(confirmable(ModalBody));



// WEBPACK FOOTER //
// ./src/template/Modals/PotentialClient/ModalBody.js